var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NoEntry50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "p_pl0gQUDnU0JyRMrkFO6a",
    x1: -792,
    x2: -792,
    y1: 6,
    y2: 42,
    gradientTransform: "translate(816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d61313"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p_pl0gQUDnU0JyRMrkFO6b",
    cx: -792,
    cy: 24,
    r: 18,
    gradientTransform: "translate(816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7575",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#fe7474",
    stopOpacity: 0.011
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#fa6f6f",
    stopOpacity: 0.052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#f46767",
    stopOpacity: 0.123
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#eb5c5c",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#df4d4d",
    stopOpacity: 0.358
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#d13b3b",
    stopOpacity: 0.522
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#bf2525",
    stopOpacity: 0.717
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#ac0c0c",
    stopOpacity: 0.936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a60505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p_pl0gQUDnU0JyRMrkFO6c",
    x1: 24,
    x2: 24,
    y1: 20,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#fbfbfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#eeeef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadae6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "no entry"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#p_pl0gQUDnU0JyRMrkFO6a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#p_pl0gQUDnU0JyRMrkFO6b)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 8,
    x: 12,
    y: 20,
    fill: "url(#p_pl0gQUDnU0JyRMrkFO6c)",
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NoEntry50);
export default __webpack_public_path__ + "static/media/icons8-no-entry-50.413280f468aa3412dba830f0edcc06bf.svg";
export { ForwardRef as ReactComponent };